import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function GoogleButton({
  className,
  label,
  variant = "outline",
  pending = false,
  children,
  ...props
}: React.ComponentPropsWithoutRef<"button"> & {
  label: string;
  variant?: React.ComponentProps<typeof Button>["variant"];
  /** Shows a spinner in place of the Google logo. */
  pending?: boolean;
}) {
  return (
    <Button variant={variant} className={cn(className)} {...props}>
      {pending ? (
        <Loader2 className="size-4 animate-spin" aria-hidden="true" />
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          className="size-4"
          aria-hidden="true"
        >
          <path
            d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
            fill="#4285F4"
          />
          <path
            d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
            fill="#34A853"
          />
          <path
            d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
            fill="#FBBC05"
          />
          <path
            d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
            fill="#EA4335"
          />
        </svg>
      )}
      {label}
      {children}
    </Button>
  );
}

export function MicrosoftButton({
  className,
  label,
  ...props
}: React.ComponentPropsWithoutRef<"button"> & {
  label: string;
}) {
  return (
    <Button variant="outline" className={cn(className)} {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 23 23"
        className="mr-2 h-4 w-4"
        fill="currentColor"
      >
        <path d="M1 1h10v10H1z" />
        <path d="M12 1h10v10H12z" />
        <path d="M1 12h10v10H1z" />
        <path d="M12 12h10v10H12z" />
      </svg>
      {label}
    </Button>
  );
}
